import simpleChangeObserver from './simpleChangeObserver';

const { onChange, publishChange } = simpleChangeObserver();
let darkMode;

// Share the resolved preference with non-React consumers without changing it.
export function setDarkMode(value) {
    if (typeof value !== 'boolean' || value === darkMode) return;
    darkMode = value;
    publishChange(value);
}
export const getDarkMode = () => darkMode;
export { onChange };
